<template>
	<div class="term-list">
		<div v-if="hasData">
			<h4 v-if="showTitle" v-html="title"></h4>
			<p v-if="description" v-html="description"></p>
			<table class="term-table" :class="getListClass">
				<thead>
					<tr>
						<th role="presentation"></th>
						<th :id="getListId + '-value'"><span class="visuallyhidden" v-text="_translate('local.region.table.value')"></span></th>
						<th :id="getListId + '-percent'" class="percent" v-text="_translate('local.region.table.percentagerank')"></th>
						<th :id="getListId + '-total'" class="total" v-text="_translate('local.region.table.numberrank')"></th>
						<th role="presentation"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(val, term) in data.data" class="term-list__item i1">
						<td role="presentation"></td>
						<td :headers="getListId + '-value'" class="value" v-html="price ? labelPrice(term) : apiLabel(term, translate)"></td>
						<td :headers="getListId + '-percent'" class="percent" v-html="getValue(val)"></td>
						<td :headers="getListId + '-total'" class="total" v-html="getValue(val, true)"></td>
						<td role="presentation"></td>
					</tr>
				</tbody>
			</table>
		</div>
		<div v-else>
      <p>No data</p>
    </div>
	</div>
</template>

<script>

	export default {

		props: {

			title: {
				type: String,
				default: 'Heading'
			},

			id: {
				type: String,
				default: '',
			},

			description: {
				type: String,
				default: ''
			},

			data: {
				type: Object,
				default: () => {}
			},

			percentage: {
				type: Boolean,
				default: true
			},

			columns: {
				type: Boolean,
				default: false,
			},

			price: {
				type: Boolean,
				default: false,
			},

			full: {
				type: Boolean,
				default: false,
			},			

			translate: {
				type: Boolean,
				default: true,
			}							

		},

		computed: {

			getListId: function() {
				let id = this.id;
				if (!id) {
					id = 'termlist-' + this._uid;
				}
				return id;
			},

			showTitle: function() {

				return ( this.title !== 'false' );

			},

			termClass: function() {
				return 'term-list__stats';
			},

			getListClass: function() {

				var c = "term-list__list",
						len = Object.keys(this.data).length;

				// if(len & 1) {
				// 	c += " odd";
				// } else {
				//   c += " even";
				// }

				if ( this.full ) {
					c+= ' term-list__list--full';
				}

				if ( this.columns ) {
					c += ' columns c-' + len;
				}

				return c;

			},

			hasData: function() {
				return Object.keys(this.data).length > 0;
			}

		},

		methods: {

			getValue: function(val, useTotal = false) {

				let total;
				if ( this.calculatePercentage ) {
						total = val;
						val = val/this.data.total * 100;
					
					// return ' - <span class="total">' +
					// 	'<svg class="visitor-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-visitor"></use></svg>' +
					// 	this.thousandSeparators(Number(total)) + '</span> <span class="separator">&rsaquo;</span> <span class="percent">' +
					// 	this.formatPercentage(Number(val) / 100, 1, false) +
					// 	'</span>';

				} else {

					total = Math.floor(this.data.total * (val/100));

				}

				return useTotal ? this.thousandSeparators(Number(total)) : this.formatPercentage(Number(val) / 100, 1, false)
				// return ' - <span class="total">' +
				// 	'<svg class="visitor-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-visitor"></use></svg>' +
				// 	this.thousandSeparators(Number(total)) + '</span> <span class="separator">&rsaquo;</span> <span class="percent">' +
				// 	this.formatPercentage(Number(val) / 100, 1, false) +
				// 	'</span>';

			},

			labelPrice: function(val) {
				val = Number(val.substr(1).replaceAll(',','').replaceAll(' ',''));
				return this.formatCurrency(val);
			}

		}

	}

</script>

<style lang="scss">

	.term-list {

		h4 {

			@include typesize('large');
			color: $blue;
			margin-top: 0;

		}

		table {

			padding: 0;
			width: 100%;
			border-collapse: collapse;
			font-size: .875rem;
			@include mq('tab') {
				font-size: 1rem;
			}

			[role="presentation"] {
				display: none;
			}

			&.term-list__list--full {
				@include mq('tab') {
					[role="presentation"] {
						display: table-cell;
						width: 20%;
					}
				} 
				@include mq('lap') {
					[role="presentation"] {
						width: 25%;
					}
				} 				
				// td {
				// 	&.percent,
				// 	&.total {
				// 		width: 90px;
				// 		@include mq('tab') {
				// 			width: 180px;
				// 		}
				// 		@include mq('lap') {
				// 			width: 260px;
				// 		}
				// 	}				
				// 	// &.value {
				// 	// 	@include mq('tab') {
				// 	// 		padding-left: 2rem;
				// 	// 	}
				// 	// 	@include mq('lap') {
				// 	// 		padding-left: 3rem;
				// 	// 	}
				// 	// }
				// }				
			}

		}

		// @include mq('lap') {
		// 	.columns {

		// 		&.c-10 {
		// 			li {
		// 				width: 50%;
		// 				&:nth-child(1) { order: 1;   background-color: $mist-light;}
		// 				&:nth-child(2) { order: 3;   background-color: transparent;}
		// 				&:nth-child(3) { order: 5;   background-color: $mist-light;}
		// 				&:nth-child(4) { order: 7;   background-color: transparent;}
		// 				&:nth-child(5) { order: 9;   background-color: $mist-light;}
		// 				&:nth-child(6) { order: 2;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(7) { order: 4;   background-color: transparent; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(8) { order: 6;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(9) { order: 8;   background-color: transparent; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(10) { order: 10; background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 			}
		// 		}

		// 		&.c-9 {
		// 			li {
		// 				width: 50%;
		// 				&:nth-child(1) { order: 1;   background-color: $mist-light;}
		// 				&:nth-child(2) { order: 3;   background-color: transparent;}
		// 				&:nth-child(3) { order: 5;   background-color: $mist-light;}
		// 				&:nth-child(4) { order: 7;   background-color: transparent;}
		// 				&:nth-child(5) { order: 9;   background-color: $mist-light;}
		// 				&:nth-child(6) { order: 2;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(7) { order: 4;   background-color: transparent; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(8) { order: 6;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(9) { order: 8;   background-color: transparent; border-left: 1px solid $mist-dark;}
		// 			}
		// 		}

		// 		&.c-8 {
		// 			li {
		// 				width: 50%;
		// 				&:nth-child(1) { order: 1;   background-color: $mist-light;}
		// 				&:nth-child(2) { order: 3;   background-color: transparent;}
		// 				&:nth-child(3) { order: 5;   background-color: $mist-light;}
		// 				&:nth-child(4) { order: 7;   background-color: transparent;}
		// 				&:nth-child(5) { order: 2;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(6) { order: 4;   background-color: transparent; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(7) { order: 6;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(8) { order: 8;   background-color: transparent; border-left: 1px solid $mist-dark;}
		// 			}
		// 		}

		// 		&.c-7 {
		// 			li {
		// 				width: 50%;
		// 				&:nth-child(1) { order: 1;   background-color: $mist-light;}
		// 				&:nth-child(2) { order: 3;   background-color: transparent;}
		// 				&:nth-child(3) { order: 5;   background-color: $mist-light;}
		// 				&:nth-child(4) { order: 7;   background-color: transparent;}
		// 				&:nth-child(5) { order: 2;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(6) { order: 4;   background-color: transparent; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(7) { order: 6;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 			}
		// 		}

		// 		&.c-6 {
		// 			li {
		// 				width: 50%;
		// 				&:nth-child(1) { order: 1;   background-color: $mist-light;}
		// 				&:nth-child(2) { order: 3;   background-color: transparent;}
		// 				&:nth-child(3) { order: 5;   background-color: $mist-light;}
		// 				&:nth-child(4) { order: 2;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(5) { order: 4;   background-color: transparent; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(6) { order: 6;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 			}										
		// 		}

		// 		&.c-5 {
		// 			li {
		// 				width: 50%;
		// 				&:nth-child(1) { order: 1;   background-color: $mist-light;}
		// 				&:nth-child(2) { order: 3;   background-color: transparent;}
		// 				&:nth-child(3) { order: 5;   background-color: $mist-light;}
		// 				&:nth-child(4) { order: 2;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(5) { order: 4;   background-color: transparent; border-left: 1px solid $mist-dark;}
		// 			}										
		// 		}

		// 		&.c-4 {
		// 			li {
		// 				width: 50%;
		// 				&:nth-child(1) { order: 1;   background-color: $mist-light;}
		// 				&:nth-child(2) { order: 3;   background-color: transparent;}
		// 				&:nth-child(3) { order: 2;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 				&:nth-child(4) { order: 4;   background-color: transparent; border-left: 1px solid $mist-dark;}
		// 			}										
		// 		}				

		// 		&.c-3 {
		// 			li {
		// 				width: 50%;
		// 				&:nth-child(1) { order: 1;   background-color: $mist-light;}
		// 				&:nth-child(2) { order: 3;   background-color: transparent;}
		// 				&:nth-child(3) { order: 2;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 			}										
		// 		}

		// 		&.c-2 {
		// 			li {
		// 				width: 50%;
		// 				&:nth-child(1) { order: 1;   background-color: $mist-light;}
		// 				&:nth-child(2) { order: 2;   background-color: $mist-light; border-left: 1px solid $mist-dark;}
		// 			}										
		// 		}				
		// 	}
		// }	

		thead {
			color: $grey;
			th {
				padding: 1rem .5rem;
				font-size: .875rem;
			}
		}
		tbody {
			tr {

				width: 100%;
				font-weight: 300;
				counter-increment: ordered-counter;

				@include mq('lap') {
						// width: 50%;
				}

				&:nth-child(odd) {
					background: $mist-light;
				}			

				td {

					padding: 1rem .5rem;
					&.value {
						text-align: left;
						&::before {
							content: counter(ordered-counter)  ' - ';
							color: $blue-dark;
						}
					}
					&.percent {
						color: $blue-dark;
					}

					&.total {
						color: $red;
					}

				}

			}

			.term-list__stat {

				color: $red;

			}

			.term-list__stats {
				.percent {
					color: $blue;
				}
				.total {
					color: $red;
				}
				.separator {
					padding: 0 .25rem;
				}
			}

		}

	}

</style>